import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: Cookies.get('token') || localStorage.getItem('token') || '',
        userInfo: null
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
            Cookies.set('token', token)
            localStorage.setItem('token', token)
        },
        REMOVE_TOKEN(state) {
            state.token = ''
            state.userInfo = null
            Cookies.remove('token')
            localStorage.removeItem('token')
        },
        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo
        }
    },
    actions: {
        login({ commit }, { token, userInfo }) {
            commit('SET_TOKEN', token)
            if (userInfo) {
                commit('SET_USER_INFO', userInfo)
            }
        },
        logout({ commit }) {
            commit('REMOVE_TOKEN')
        }
    },
    getters: {
        isAuthenticated: state => !!state.token,
        userInfo: state => state.userInfo
    }
})
